import { render, staticRenderFns } from "./ReleaseCard.vue?vue&type=template&id=6c20eeee&scoped=true&"
import script from "./ReleaseCard.vue?vue&type=script&lang=js&"
export * from "./ReleaseCard.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseCard.vue?vue&type=style&index=0&id=6c20eeee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c20eeee",
  null
  
)

export default component.exports